export default __webpack_public_path__ + "static/3-dc13f6ed7f83e2b275a264c6ca03c91d.svg";